import utils from "../utils";
import env from '../env';
import { isMin } from '../lib/css-emotion'
import React from "react";
import { Link } from "react-router-dom";
import { handleElementLink } from "../lib/router/handleLink";

export const isMobile = () => {
  // isMin.md() ==> min-width: 768px
  return !isMin.md()
}

export function resourcePath(url){
  if (!url) return null;
  if (url && url.indexOf('/assets/') === 0) return url;
  return utils.url.isExternalLink(url)? url : env.resourceBase + url;
}

export function fullUrl(url){
  return utils.url.isExternalLink(url)? url : env.baseOrigin + url;
}

export function SiteLinkNew(props) {
  const { children, to, target, onClick, ...other } = props;

  function goToLink(e) {
    try {
      const isCmsEdit = document.querySelector("body").classList.contains("cmsedit");
      if (isCmsEdit) {
        e.preventDefault();
        return;
      }
    } catch (e) {}

    //console.log(e, e.target);
    if (onClick) onClick(e);
    const processed = handleElementLink(e.target);
    //console.log(processed)
    if (processed.handled) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  return utils.url.isExternalLink(to) ? (
    <a href={to} target={target || "_blank"} rel="noopener noreferrer" onClick={(e) => goToLink(e)} {...other}>
      {children}
    </a>
  ) : (
    <Link to={to} onClick={(e) => goToLink(e)} {...other}>
      {children}
    </Link>
  );
}


export const isNZ = env.locale === 'nz'

